import { render } from "./EventModal.vue?vue&type=template&id=4c315ca8&ts=true"
import script from "./EventModal.vue?vue&type=script&lang=ts"
export * from "./EventModal.vue?vue&type=script&lang=ts"

import "./EventModal.vue?vue&type=style&index=0&id=4c315ca8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__